<template lang="pug">
v-container
  template(v-if="selectedProject")
    v-card.pointer(v-for="network in networks" :key="network.id" class="mx-auto mb-1 pointer" max-width="400" @click.native="goToNetwork(network)")
      v-card-title {{ network.name }}
      div.archive-info
        span(v-if="isMerch && networkStatistic[network.id]") Сихронизировано {{ networkStatistic[network.id].synced }} из {{ networkStatistic[network.id].total }}
  v-card(v-if="loading" class="mx-auto" flat max-width="50")
    v-progress-circular(:size="50" color="primary" indeterminate )

  v-card(v-if="error" class="mx-auto" max-width="400")
    v-card-title Что-то пошло не по плану
      v-spacer
      v-icon(color="red") mdi-alert
    v-card-subtitle {{ error }}



</template>


<script>
// import { projectService } from '@/_services'
import { mapMutations, mapState } from "vuex";
import dataService from '../../../_services/dataService';
import { offlineReportService } from "../../../_services/offlineReportService";

export default {
  data: () => ({
    loading:false,
    error: null,
    networks:[],
    networkStatistic: {}
  }),

  mounted() {
    if (!this.selectedProject) this.loadProject()
    else {
      this.setAppBarTitle(this.selectedProject.name)
    }
    this.loadNetworks()
    window.addEventListener('app:online-sync', this.loadNetworks)
  },

  beforeDestroy() {
    window.removeEventListener('app:online-sync', this.loadNetworks)
  },

  destroyed() {
    this.setSelectedProject(null)
  },

  computed: {
    ...mapState("project", ["selectedProject"]),

    isMerch() {
      let role = localStorage.getItem('role')
      return role == "MERCH"
    }
  },

  methods: {
    ...mapMutations(['setAppBarTitle']),
    ...mapMutations("project", ["setSelectedProject"]),
    ...mapMutations("network", ["setSelectedNetwork"]),

    async getNetworkStatistic(networks) {
      let statistic = {}
      for(const network of networks) {
        statistic[network.id] = await offlineReportService.getNetworkReportStatistic(network.id)
      }
      this.networkStatistic = statistic
    },

    loadProject(){
      this.setAppBarTitle('loading')
      // projectService.loadProject(this.$route.params.id)
      dataService.loadProject(this.$route.params.id)
      .then(data => {
        this.setSelectedProject(data)
        this.setAppBarTitle(this.selectedProject.name)
      })
      .catch(error => {
        this.setAppBarTitle(this.error)
      })
    },

    loadNetworks(){
      this.loading = true
      // networkService.loadMyNetwork(this.$route.params.id)
      this.networks = []
      dataService.getNetworks(this.$route.params.id)
      .then(data => {
        this.getNetworkStatistic(data)
        this.networks = data
        this.loading = false
      })
      .catch(error => {
        this.error = error
        this.loading = false
      })
    },

    goToNetwork(n){
      this.setSelectedNetwork(n)
      this.$router.push(`/project/${this.selectedProject.id}/network/${n.id}`)
    }
  }
}
</script>
<style scoped>
.archive-info {
  font-size: 10px;
  line-height: 22px;
  color: #00000099;
  width: 100%;
  margin-top: -10px;
  display: flex;
  padding: 0 16px 16px 16px;
}
</style>